/** @format */

import { Component, HostBinding, Input, OnInit } from '@angular/core';

import { KillswitchService, UtilityService } from '@shared/data-access/services';

import { Template } from '../template.interface';

import { chain } from '@core/chain';
import { take } from 'rxjs/operators';

@Component({
	selector: 'clp-template-spot-with-deals',
	templateUrl: './template-spot_deals.component.html',
	styleUrl: './template-spot_deals.component.scss',
	standalone: false
})
export class TemplateSpotWithDealsComponent implements OnInit {
	@Input() data: Template;
	@Input() categoryData: any;
	@Input() pageType: string;
	@HostBinding('class.template-wrapper') templateWrapper = true;

	GAMId = 'top_banner';
	chainIdentifier: string = chain.chainIdentifierAbbr;
	clpGoogleAdManagerEnabled = false;
	enableTooltipSurvey = false;

	constructor(
		private readonly killSwitchService: KillswitchService,
		private readonly utilityService: UtilityService
	) {}

	ngOnInit(): void {
		this.killSwitchService
			.getKillSwitchesEnvironment$()
			.pipe(take(1))
			.subscribe((data) => {
				this.clpGoogleAdManagerEnabled = this.utilityService.checkKillSwitch(
					'clpGoogleAdManagerEnabled',
					data,
					this.chainIdentifier
				);
				this.enableTooltipSurvey = this.utilityService.checkKillSwitch(
					'enableTooltipSurvey',
					data,
					this.chainIdentifier
				);
			});
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	trackByFn(index: number, _item: any): number {
		return index;
	}
}
